import { Table } from '@bancobarigui/barihaus';
import { DadosAreaConstruida } from '@/features/laudo/types/laudo-wizard.types';
import type { TabelaAreaConstruidaProps } from './types';
import {
  useDadosCalculados,
  useSincronizarDados,
  useDadosComparacao,
  useMediaValorFinal,
} from './hooks';
import { createColumns } from './components/TabelaAreaConstruidaColumns';
import * as styles from './styles';
import { ReviewFieldWrapper } from '../../../ReviewFieldWrapper';


export function TabelaAreaConstruida({ dados, onUpdate, valoresTotais, disabled, displayIdMap }: TabelaAreaConstruidaProps) {
  const dadosCalculados = useDadosCalculados(dados, valoresTotais);

  useSincronizarDados(dadosCalculados, dados, onUpdate);

  const dadosComparacao = useDadosComparacao(dadosCalculados);
  const _mediaValorFinal = useMediaValorFinal(dadosComparacao);

  const handleInputChange = (index: number, field: keyof DadosAreaConstruida, value: number) => {
    const novosDados = [...dados];
    novosDados[index] = {
      ...novosDados[index],
      [field]: value,
    } as DadosAreaConstruida;
    onUpdate(novosDados);
  };

  const columns = createColumns(dadosCalculados, handleInputChange, disabled, displayIdMap);

  return (
    <div style={styles.containerStyle}>
      <div style={styles.titleContainerStyle}>
        <ReviewFieldWrapper
          fieldPath="amostras.tabelaAreaConstruida"
          fieldLabel="Tabela de Área Construída"
          stepName="Metodologia"
          linkInline={true}
        >
          <h4 style={styles.titleStyle}>Cálculo de Valor da Área Construída</h4>
        </ReviewFieldWrapper>
      </div>

      <Table
        dataSource={dadosCalculados as any[]}
        columns={columns as any}
        rowKey="identificacao"
        pagination={false}
        scroll={{ x: 1200 }}
        bordered
        size="small"
        rowClassName={(record: any) => {
          return record.identificacao === 'Avaliando' ? 'row-avaliando' : '';
        }}
      />

      <style>{styles.tableStyles}</style>
    </div>
  );
}
